import textBalancer from '../lib/text-balancer'

var balancer = textBalancer.balanceText('[data-component~="balancer"]')
window.GPLA_APP.on('after', () => {
  if (balancer) balancer.destroy()
  balancer = textBalancer.balanceText('[data-component~="balancer"]')
})